import { render, staticRenderFns } from "./CuratorApprove.vue?vue&type=template&id=16df927f&scoped=true&"
import script from "./CuratorApprove.vue?vue&type=script&lang=js&"
export * from "./CuratorApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df927f",
  null
  
)

export default component.exports